export default {"src":"/_next/static/media/snorkelen.88903b7d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};